const CALLBACK_ERRORS = {
  access_denied: {
    message: 'A autorização do Google foi cancelada.',
    action: 'Clique em conectar novamente e aceite as permissões solicitadas.',
  },
  invalid_state: {
    message: 'A tentativa de conexão com o Google expirou.',
    action: 'Inicie uma nova autorização.',
  },
  missing_state: {
    message: 'Não foi possível confirmar a origem da autorização do Google.',
    action: 'Volte à configuração e tente conectar novamente.',
  },
  token_exchange_failed: {
    message: 'O Google não concluiu a conexão da conta.',
    action: 'Tente autorizar novamente em alguns instantes.',
  },
  missing_refresh_token: {
    message: 'O Google não liberou a autorização necessária para manter a conexão.',
    action: 'Revogue o acesso anterior na conta Google e conecte novamente.',
  },
};

const TECHNICAL_MESSAGE_PATTERN = /(row[- ]level security|violates.*policy|pgrst|supabase|network error|request failed with status code|fetch failed|econn|etimedout)/i;

export const getGoogleBusinessErrorInfo = (
  error,
  fallback = 'Não foi possível concluir a operação com o Google.',
) => {
  const response = error?.response?.data || {};
  const responseMessage = typeof response?.error === 'string'
    ? response.error.trim()
    : typeof response?.message === 'string'
      ? response.message.trim()
      : '';
  const localMessage = String(error?.message || '').trim();
  const candidate = responseMessage || localMessage;
  const safeMessage = candidate && !TECHNICAL_MESSAGE_PATTERN.test(candidate)
    ? candidate
    : fallback;

  return {
    message: safeMessage || fallback,
    action: typeof response?.action === 'string' ? response.action.trim() : '',
    code: typeof response?.code === 'string' ? response.code : '',
    category: typeof response?.category === 'string' ? response.category : '',
  };
};

export const getGoogleBusinessErrorMessage = (error, fallback) => {
  const info = getGoogleBusinessErrorInfo(error, fallback);
  return [info.message, info.action].filter(Boolean).join(' ');
};

export const getGoogleBusinessCallbackErrorInfo = (reason) => (
  CALLBACK_ERRORS[String(reason || '').trim()] || {
    message: 'A autorização do Google não foi concluída.',
    action: 'Confira se sua conta administra a ficha e tente novamente.',
  }
);

export default getGoogleBusinessErrorMessage;
